import PurchaseConfig from "./PurchaseConfig";

export default PurchaseConfig;
